import {ActiveView, PasswordPolicy} from "@/modules/login/models/state";
import {GetterTree} from "vuex";
import {RootState} from "@/store/state";
import {LoginPageState} from "@/modules/login/store/state";
import { LoginGetters } from "./types";

const getters: GetterTree<LoginPageState, RootState> = {
  [LoginGetters.GET_IS_LOGIN_MODE](state: LoginPageState): boolean {
    return state.activeView === ActiveView.Login;
  },

  [LoginGetters.GET_PASSWORD_POLICY](state: LoginPageState): PasswordPolicy {
    return state.changePassword.policy;
  },

  [LoginGetters.GET_ERROR_MESSAGE](state: LoginPageState): string {
    return state.error.message;
  },
  
  [LoginGetters.GET_ERROR_TIMEOUT](state: LoginPageState): number {
    return state.error.timeout;
  }
};

export default getters;
